export const state = () => ({

});

export const mutations = {

};

export const actions = {
  putToCart: async function (params, item) {
    const {
      commit,
    } = params;

    commit('appState/setLoading', { putToCart: true }, { root: true });

    const response = await this.$api.agent.transport.post('/cart', {
      product_id: item.productId,
      quantity: item.quantity,
    }).then((res) => res.data).catch((err) => ({ error: err.response }));

    commit('appState/setLoading', { putToCart: false }, { root: true });

    if (response.error) {
      return {
        isSuccess: false,
        errorMessage: response.error?.data?.message || 'Ошибка сервера',
      };
    }

    return {
      isSuccess: true,
    };
  },
  updateCartItem: async function (params, item) {
    const {
      commit,
    } = params;

    commit('appState/setLoading', { putToCart: true }, { root: true });

    const response = await this.$api.agent.transport.put(`/cart/${item.cartItemId}`, {
      quantity: item.quantity,
    }).then((res) => res.data).catch((err) => ({ error: err.response }));

    commit('appState/setLoading', { putToCart: false }, { root: true });

    if (response.error) {
      let errorMessage = response.error?.data?.message;
      if (!errorMessage && Array.isArray(response.error?.data)) {
        errorMessage = response.error?.data.map((t) => t.message).join(';<br/>');
      }

      return {
        isSuccess: false,
        errorMessage: errorMessage || 'Ошибка сервера',
      };
    }

    return {
      isSuccess: true,
    };
  },
};
